<template>
  <svg
    width="216"
    height="162"
    viewBox="0 0 216 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1635_22470)">
      <mask
        id="mask0_1635_22470"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="216"
        height="162"
      >
        <path d="M216 0H0V162H216V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1635_22470)">
        <path
          d="M171.501 8.99934C202.661 23.2356 221.115 105.207 175.001 135.999C128.887 166.791 22.7698 137 11 89.5C1.70804 51.9999 19.8553 32.9445 65.1126 35.7234C122.113 39.2232 140.341 -5.23694 171.501 8.99934Z"
          fill="#E7E8E9"
        />
        <path
          d="M24 135H192V47.5V39.5V35H108H24V39.5V47.5V135Z"
          fill="#DBF0EB"
        />
        <path d="M24 35H108H192V24.5H108H24V35Z" fill="#DBF0EB" />
        <path
          d="M24 35H108H192M24 35V47.5M24 35V39.5M24 35V24.5M192 35V47.5M192 35V39.5M192 35V24.5M24 47.5V135H192V47.5M24 47.5V39.5M24 39.5V24.5M24 24.5H108H192M192 47.5V39.5M192 39.5V24.5"
          stroke="#97D3C6"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <path d="M52 99.6665H40V106.667H52V99.6665Z" fill="#97D3C6" />
        <path d="M52 106.667H40V123H52V106.667Z" fill="#53B7A1" />
        <path d="M72 81H60V111.333H72V81Z" fill="#97D3C6" />
        <path d="M72 111.333H60V123H72V111.333Z" fill="#53B7A1" />
        <path d="M92 95H80V104.333H92V95Z" fill="#97D3C6" />
        <path d="M92 104.333H80V123H92V104.333Z" fill="#53B7A1" />
        <path d="M112 85.6665H100V99.6665H112V85.6665Z" fill="#97D3C6" />
        <path d="M112 99.6665H100V123H112V99.6665Z" fill="#53B7A1" />
        <path
          d="M155 107C152.242 107 149.511 106.457 146.964 105.401C144.416 104.346 142.101 102.799 140.151 100.849C138.201 98.8992 136.654 96.5842 135.599 94.0363C134.543 91.4885 134 88.7577 134 86C134 83.2422 134.543 80.5115 135.599 77.9636C136.654 75.4158 138.201 73.1008 140.151 71.1507C142.101 69.2007 144.416 67.6539 146.964 66.5985C149.512 65.5432 152.242 65 155 65V73.4C153.345 73.4 151.707 73.7259 150.178 74.3591C148.649 74.9923 147.26 75.9204 146.09 77.0904C144.92 78.2605 143.992 79.6495 143.359 81.1782C142.726 82.7069 142.4 84.3453 142.4 86C142.4 87.6546 142.726 89.2931 143.359 90.8218C143.992 92.3505 144.92 93.7395 146.09 94.9095C147.26 96.0796 148.649 97.0077 150.178 97.6409C151.707 98.2741 153.345 98.6 155 98.6V107Z"
          fill="#76C6B5"
        />
        <path
          d="M155 65C159.435 65 163.756 66.404 167.343 69.0106C170.931 71.6173 173.602 75.2929 174.972 79.5106L166.983 82.1064C166.161 79.5758 164.559 77.3704 162.406 75.8064C160.253 74.2424 157.661 73.4 155 73.4V65Z"
          fill="#97D3C6"
        />
        <path
          d="M174.991 79.5684C176.006 82.7232 176.26 86.0734 175.732 89.3451C175.204 92.6168 173.909 95.7171 171.954 98.3926C169.998 101.068 167.437 103.243 164.48 104.739C161.523 106.235 158.253 107.009 154.939 107L154.964 98.5999C156.952 98.6057 158.914 98.1408 160.688 97.2432C162.462 96.3456 163.999 95.0408 165.172 93.4355C166.346 91.8303 167.122 89.9701 167.439 88.007C167.756 86.044 167.604 84.0339 166.995 82.141L174.991 79.5684Z"
          fill="#53B7A1"
        />
        <path
          d="M110 47H42C40.8954 47 40 47.8954 40 49C40 50.1046 40.8954 51 42 51H110C111.105 51 112 50.1046 112 49C112 47.8954 111.105 47 110 47Z"
          fill="#97D3C6"
        />
        <path
          d="M79 47H42C40.8954 47 40 47.8954 40 49C40 50.1046 40.8954 51 42 51H79C80.1046 51 81 50.1046 81 49C81 47.8954 80.1046 47 79 47Z"
          fill="#53B7A1"
        />
        <path
          d="M110 55H42C40.8954 55 40 55.8954 40 57C40 58.1046 40.8954 59 42 59H110C111.105 59 112 58.1046 112 57C112 55.8954 111.105 55 110 55Z"
          fill="#97D3C6"
        />
        <path
          d="M100 55H42C40.8954 55 40 55.8954 40 57C40 58.1046 40.8954 59 42 59H100C101.105 59 102 58.1046 102 57C102 55.8954 101.105 55 100 55Z"
          fill="#53B7A1"
        />
        <path
          d="M110 63H42C40.8954 63 40 63.8954 40 65C40 66.1046 40.8954 67 42 67H110C111.105 67 112 66.1046 112 65C112 63.8954 111.105 63 110 63Z"
          fill="#97D3C6"
        />
        <path
          d="M56 63H42C40.8954 63 40 63.8954 40 65C40 66.1046 40.8954 67 42 67H56C57.1046 67 58 66.1046 58 65C58 63.8954 57.1046 63 56 63Z"
          fill="#53B7A1"
        />
        <path
          d="M30 32C31.1046 32 32 31.1046 32 30C32 28.8954 31.1046 28 30 28C28.8954 28 28 28.8954 28 30C28 31.1046 28.8954 32 30 32Z"
          fill="#97D3C6"
        />
        <path
          d="M38 32C39.1046 32 40 31.1046 40 30C40 28.8954 39.1046 28 38 28C36.8954 28 36 28.8954 36 30C36 31.1046 36.8954 32 38 32Z"
          fill="#97D3C6"
        />
        <path
          d="M46 32C47.1046 32 48 31.1046 48 30C48 28.8954 47.1046 28 46 28C44.8954 28 44 28.8954 44 30C44 31.1046 44.8954 32 46 32Z"
          fill="#97D3C6"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1635_22470">
        <rect width="216" height="162" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
